import { render } from "./Speech.vue?vue&type=template&id=14921180"
import script from "./Speech.vue?vue&type=script&lang=js"
export * from "./Speech.vue?vue&type=script&lang=js"

import "./Speech.vue?vue&type=style&index=0&id=14921180&lang=css"

import exportComponent from "/home/node/site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__